import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  locationBlocks: [],
  isLoadingLocationBlocks: false,
  blocksBySiteCode: [],
  isLoadingBlocksBySiteCode: false,
  filterBlocksBySiteCode: [],
  isLoadingFilterBlocksBySiteCode: false,
  locationBlockDetails: {},
  isLoadingLocationBlockDetails: false,
  blockDetails: {},
  isLoadingBlockDetails: false,
  isLoading: false,
  error: null,
  gatewaysByBlockCode: [],
  isLoadingGatewaysByBlockCode: false,
  blockToSublocation: [],
  isLoadingBlockToSublocation: false,

  blockSublocationTypes: [],
  isLoadingBlockSublocationTypes: false,
};

export const getLocationBlocks: any = createAsyncThunk(
  "content/getLocationBlocks",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/Block/getall`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  }
);

export const getGatewaysByBlockCode: any = createAsyncThunk(
  "content/getGatewaysByBlockCode",
  async ({ blockCode, PageNumber, pageSize, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/slpapp/Block/gatewaysByBlockCode`, {
      params: { blockCode, PageNumber, pageSize, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  }
);

export const getLocationBlockByCode: any = createAsyncThunk(
  "content/getLocationBlockById",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/Dashboard/getBlockByBlockCode`, {
      params: { blockCode },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const getBlockDetailsByCode: any = createAsyncThunk(
  "content/getBlockDetailsByCode",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/Block/byBlockCode`, {
      params: { blockCode },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const addBlock: any = createAsyncThunk(
  "content/addBlock",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/Block`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const editBlock: any = createAsyncThunk(
  "content/editBlock",
  async ({ payload, blockCode }: any) => {
    const res = await axios.put(`/slpapp/Block`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { blockCode },
    });

    const data = await res.data;
    return data;
  }
);

export const addBlockContacts: any = createAsyncThunk(
  "content/addBlockContacts",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/BlockContact`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const getBlockContacts: any = createAsyncThunk(
  "content/getBlockContacts",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/BlockContact`, {
      params: { blockCode },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteBlock: any = createAsyncThunk(
  "content/deleteBlock",
  async ({ blockCode }: any) => {
    const res = await axios.delete(`/slpapp/Block`, {
      params: { blockCode },
    });

    const data = await res.data.data;
    return data;
  }
);

export const getBlocksBySiteCode: any = createAsyncThunk(
  "content/getBlocksBySiteCode",
  async ({ siteCode }: any) => {
    const res = await axios.get(`/slpapp/Block/bySiteCode`, {
      params: { siteCode },
    });

    const data = await res?.data;
    return data;
  }
);

export const getFilterBlocksBySiteCode: any = createAsyncThunk(
  "content/getFilterBlocksBySiteCode",
  async ({ siteCode }: any) => {
    const res = await axios.get(`/slpapp/Block/bySiteCode`, {
      params: { siteCode, isWithAsset: true },
    });

    const data = await res?.data;
    return data;
  }
);

export const postFloorToBlock: any = createAsyncThunk(
  "content/postFloorToBlock",
  async ({ payload, blockCode }: any) => {
    if (payload?.floorImageUrl) {
      payload.floorImageUrl = "Floor image exists";
    }

    const formData = new FormData();
    formData.append("uploadedFloorImage", payload.uploadedFloorImage);
    const floorLocationString = JSON.stringify(payload.floorLocations);

    let customFloorCode = payload.floorCode;
    if (payload.floorCode.includes("-")) {
      customFloorCode = payload.floorCode.split("-")[0];
    }

    const res = await axios.post(
      `/slpapp/BlockToFloor?blockCode=${blockCode}&FloorCode=${customFloorCode}&id=${
        payload.id || 0
      }&blockName=${payload.blockName}&BlockLocationTypeId=${
        payload.blockLocationTypeId
      }&FloorImageUrl=${payload?.floorImageUrl}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const data = await res?.data;
    return data;
  }
);

export const getBlockSublocationTypes: any = createAsyncThunk(
  "content/getBlockSublocationTypes",
  async (params) => {
    const res = await axios.get(`/slpapp/BlockSubLocationType/getall`, {
      params,
    });

    const data = res?.data?.data;
    //  ;
    return data;
  }
);

export const getBlockToSublocation: any = createAsyncThunk(
  "content/getBlockToSublocation",
  async ({ blockCode }: any) => {
    const res = await axios.get(`/slpapp/BlockToSubLocation`, {
      params: { blockCode },
    });

    const data = await res?.data?.data;
    return data;
  }
);

export const postBlockToSublocation: any = createAsyncThunk(
  "content/postBlockToSublocation",
  async (payload) => {
    // debugger
    const res = await axios.post(`/slpapp/BlockToSubLocation`, payload);

    const data = await res?.data;
    return data;
  }
);

export const locationBlockSlice = createSlice({
  name: "locationBlock",
  initialState,
  reducers: {
    setBlockOptionsData(state, action) {
      state.blocksBySiteCode = action.payload;
    },

    setBlockToSublocation(state, action) {
      state.blockToSublocation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLocationBlocks.pending, (state) => {
      state.isLoadingLocationBlocks = true;
    });
    builder.addCase(getLocationBlocks.fulfilled, (state, action) => {
      state.isLoadingLocationBlocks = false;
      state.locationBlocks = action.payload;
    });
    builder.addCase(getLocationBlocks.rejected, (state, action) => {
      state.isLoadingLocationBlocks = false;
      state.error = action.error.message;
    });

    builder.addCase(getGatewaysByBlockCode.pending, (state) => {
      state.isLoadingGatewaysByBlockCode = true;
    });
    builder.addCase(getGatewaysByBlockCode.fulfilled, (state, action) => {
      state.isLoadingGatewaysByBlockCode = false;
      state.gatewaysByBlockCode = action.payload;
    });
    builder.addCase(getGatewaysByBlockCode.rejected, (state, action) => {
      state.isLoadingGatewaysByBlockCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getLocationBlockByCode.pending, (state) => {
      state.isLoadingLocationBlockDetails = true;
    });
    builder.addCase(getLocationBlockByCode.fulfilled, (state, action) => {
      state.isLoadingLocationBlockDetails = false;
      state.locationBlockDetails = action.payload;
    });
    builder.addCase(getLocationBlockByCode.rejected, (state, action) => {
      state.isLoadingLocationBlockDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlockDetailsByCode.pending, (state) => {
      state.isLoadingBlockDetails = true;
    });
    builder.addCase(getBlockDetailsByCode.fulfilled, (state, action) => {
      state.isLoadingBlockDetails = false;
      state.blockDetails = action.payload;
    });
    builder.addCase(getBlockDetailsByCode.rejected, (state, action) => {
      state.isLoadingBlockDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(addBlock.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addBlock.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addBlock.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editBlock.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editBlock.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editBlock.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteBlock.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteBlock.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteBlock.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlocksBySiteCode.pending, (state) => {
      state.isLoadingBlocksBySiteCode = true;
    });
    builder.addCase(getBlocksBySiteCode.fulfilled, (state, action) => {
      state.isLoadingBlocksBySiteCode = false;
      state.blocksBySiteCode = action.payload;
    });
    builder.addCase(getBlocksBySiteCode.rejected, (state, action) => {
      state.isLoadingBlocksBySiteCode = false;
      state.error = action.error.message;
    });

    builder.addCase(getFilterBlocksBySiteCode.pending, (state) => {
      state.isLoadingFilterBlocksBySiteCode = true;
    });
    builder.addCase(getFilterBlocksBySiteCode.fulfilled, (state, action) => {
      state.isLoadingFilterBlocksBySiteCode = false;
      state.filterBlocksBySiteCode = action.payload;
    });
    builder.addCase(getFilterBlocksBySiteCode.rejected, (state, action) => {
      state.isLoadingFilterBlocksBySiteCode = false;
      state.error = action.error.message;
    });

    builder.addCase(postFloorToBlock.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(postFloorToBlock.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(postFloorToBlock.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlockToSublocation.pending, (state) => {
      state.isLoadingBlockToSublocation = true;
    });
    builder.addCase(getBlockToSublocation.fulfilled, (state, action) => {
      state.isLoadingBlockToSublocation = false;
      state.blockToSublocation = action.payload;
    });
    builder.addCase(getBlockToSublocation.rejected, (state, action) => {
      state.isLoadingBlockToSublocation = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlockSublocationTypes.pending, (state) => {
      state.isLoadingBlockSublocationTypes = true;
    });
    builder.addCase(getBlockSublocationTypes.fulfilled, (state, action) => {
      state.isLoadingBlockSublocationTypes = false;
      state.blockSublocationTypes = action.payload;
    });
    builder.addCase(getBlockSublocationTypes.rejected, (state, action) => {
      state.isLoadingBlockSublocationTypes = false;
      state.error = action.error.message;
    });

    builder.addCase(getBlockContacts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBlockContacts.fulfilled, (state, action) => {
      state.blockDetails.contactDetail = action.payload.data.contactDetail;
    });
    builder.addCase(getBlockContacts.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { setBlockOptionsData, setBlockToSublocation } =
  locationBlockSlice.actions;

export default locationBlockSlice.reducer;
